// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__on7BI","animatedGradient":"Home_animatedGradient__BiPum","animatedGrid":"Home_animatedGrid__fMRqA","contentWrapper":"Home_contentWrapper__-+Iao"};